import DeleteIcon from "@mui/icons-material/Delete";
import { Box, IconButton, Stack } from "@mui/material";
import { FormikProps } from "formik";

import { FormikAutocomplete } from "@/common/components/fields/formik/formik-autocomplete/FormikAutocomplete";
import { FormikDatePicker } from "@/common/components/fields/formik/formik-date-picker/FormikDatePicker";
import { useTranslation } from "@/translations";

import { GoalsResultsFormValues } from "../hooks/useGoalsResults";

interface Props {
  formik: FormikProps<GoalsResultsFormValues>;
  index: number;
  goalOptions: string[];
  onDelete: () => void;
}

export const GoalsResultsRow = ({ formik, index, goalOptions, onDelete }: Props) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" gap={2} alignItems="flex-start">
      <Box sx={{ width: "50%" }}>
        <FormikDatePicker
          formik={formik}
          path={`rows.${index}.achievementDate`}
          label={t("clients.goalsResults.achievementDate")}
          required
        />
      </Box>

      <Box sx={{ flex: 1 }}>
        <FormikAutocomplete
          formik={formik}
          path={`rows.${index}.goalResult`}
          label={t("clients.goalsResults.goalResult")}
          options={goalOptions}
          required
        />
      </Box>

      <IconButton onClick={onDelete} size="medium" color="default" aria-label={t("clients.goalsResults.deleteRow")}>
        <DeleteIcon />
      </IconButton>
    </Stack>
  );
};

export default GoalsResultsRow;
